import { useState } from 'react'

export type TUseDialog<T> = {
  isOpen: boolean
  open: (data?: T) => void
  close: () => void
  onClose: () => void
  toggle: () => void
  data?: T
  // closeButton: string
}

const useDialog = <T>(): TUseDialog<T> => {
  const [isOpen, setIsOpen] = useState(false)

  const [data, setData] = useState<T>()

  const open = (data: T): void => {
    setData(data)
    setIsOpen(true)
  }

  const close = (): void => setIsOpen(false)

  const toggle = (): void => setIsOpen(!isOpen)

  return {
    isOpen,
    open,
    close,
    onClose: close,
    toggle,
    data,
    // closeButton: i18n.t('cancel_btn', 'Abbrechen'),
  }
}

export default useDialog
